import React from 'react';
import { NavLink } from 'react-router-dom';
import { isPowerUser } from '../../auth/authUtils';

export interface SKULinkProps {
  skuId?: string | number | null;
  publisherCompanyId?: string | number | null;
  skuName?: string | null;
  className?: string;
  currentUser?: unknown;
  onClick?: () => void;
}

function SKULink({
  skuId,
  publisherCompanyId,
  skuName,
  className,
  currentUser,
  onClick,
}: SKULinkProps) {
  const handleOnClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <div className={className}>
      {currentUser && isPowerUser(currentUser) ? (
        <>
          {skuId ? (
            <>
              <NavLink to={`/sku/${skuId}`} onClick={handleOnClick}>
                {skuName}
              </NavLink>
            </>
          ) : (
            <>{skuName}</>
          )}
        </>
      ) : (
        <>{skuName}</>
      )}
    </div>
  );
}
export default SKULink;
